<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelParentage"
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Qual o nome da sua mãe?"
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="parentageForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        [fieldValue]="motherName"
        [placeholder]="placeholder"
        [error]="error"
        [id]="idComponentParentage"
        [textError]="textError"
        (textChange)="motherName = $event; errorMsg()"
        type="text"
        [idLabel]="idLabel"
        [replaceStrTo]="'name'"
        [label]="label"
        name="docParentage"
        formControlName="docParentage"
        [disabled]="!this.edit"
        ngDefaultControl
      >
      </app-ion-common-input>
    </form>
  </div>

  <app-ion-common-button
    [id]="idButtonParentage"
    class="hidden"
    [ngClass]="{ hidden: !buttonEnable || motherName.length === 0 }"
    [attr.aria-hidden]="!buttonEnable"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>
